"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Mail, User, MessageSquare } from "lucide-react";
export default function YourTrustedWeldingExperts() {
  const [scrollY, setScrollY] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<"idle" | "success" | "error">("idle");
  const sectionRef = useRef<HTMLElement>(null);
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.3
  });
  const {
    ref: formRef,
    isVisible: isFormVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.2
  });
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        const sectionTop = rect.top;
        const windowHeight = window.innerHeight;
        if (sectionTop < windowHeight && rect.bottom > 0) {
          setScrollY(window.scrollY * 0.5);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("idle");
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      setSubmitStatus("success");
      setFormData({
        name: "",
        email: "",
        message: ""
      });
    } catch (error) {
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <section ref={sectionRef} className="relative min-h-screen w-full overflow-hidden bg-dark-background" aria-label="Hero section with steel texture background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1427264/img/steel_texture_background.png)]" style={{
      transform: `translateY(${scrollY}px)`,
      willChange: "transform"
    }} role="img" aria-label="Steel texture background showcasing industrial metalwork" />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-background/80 via-dark-background/40 to-dark-background/80" />

      {}
      <div ref={contentRef} className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 py-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-5xl text-center">
          {}
          <h1 className={`font-display text-5xl font-bold text-white transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] sm:text-6xl lg:text-7xl ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
          textShadow: "0 4px 16px rgba(0, 0, 0, 0.5)"
        }}>
            Your Trusted Welding Experts
          </h1>

          {}
          <p className={`mt-8 text-lg text-white/90 transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] sm:text-xl lg:text-2xl ${isVisible ? "translate-y-0 opacity-100 delay-200" : "translate-y-8 opacity-0"}`} style={{
          textShadow: "0 2px 8px rgba(0, 0, 0, 0.4)",
          transitionDelay: "200ms"
        }}>Romero Welding Inc. specializes in industrial and commercial welding, structural steel work, and custom metal fabrication in Laguna Beach, California. This website is currently under construction. Please call <a className="text-primary-light underline hover:text-primary transition-colors duration-[var(--duration-fast)]" data-ast-id="f:/src/pages/Home/sections/YourTrustedWeldingExperts.tsx|sig:qiqqp3" data-ast-start="3975" data-ast-end="4257" href="tel:+19494944522">+1 (949) 494-4522</a> for assistance.<br /><br /><br />Please scroll down for more info.<br /><br /></p>

          {}
          <div className={`mt-12 inline-block transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "translate-y-0 opacity-100 delay-[400ms]" : "translate-y-8 opacity-0"}`} style={{
          transitionDelay: "400ms"
        }}>
            {}
          </div>
        </div>

        {}
        <div ref={formRef} className={`mx-auto mt-24 w-full max-w-2xl transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isFormVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {}
        </div>
      </div>
    </section>;
}